import { BASE_URL } from "../configs";
import axiosInstance from "./axios"

export async function deleteProjectUser(id) {
    let url = `${BASE_URL}/api/project-user/${id}`;

    const res = await axiosInstance.delete(url)
    return res.data.Data;
}
